export interface Skill {
  category: string;
  skillSet: string[];
}
export const skills = [
  {
    category: "Programming Languages",
    skillSet: [
      "Java",
      "Python",
      "C#",
      "TypeScript",
      "JavaScript",
      "Dart",
      "PHP",
    ],
  },
  {
    category: "Web & Mobile Technologies",
    skillSet: [
      "React",
      "Angular",
      "Flutter",
      "Ionic",
      "Bootstrap",
      "HTML",
      "CSS",
    ],
  },
  {
    category: "Back-End Technologies",
    skillSet: [
      "NodeJS",
      "ExpressJS",
      ".Net",
      "NestJS",
      "Spring Boot",
      "Microservices",
      "REST",
      "Django",
    ],
  },
  {
    category: "Database Technologies",
    skillSet: ["MySQL", "MongoDB", "PostgreSQL", "Firestore"],
  },
  {
    category: "Cloud & DevOps",
    skillSet: [
      "AWS",
      "Docker",
      "GCP",
      "Firebase",
      "Jenkins",
      "Git/GitHub",
      "CI/CD",
      "Cloud Functions",
    ],
  },
  {
    category: "Other Skills",
    skillSet: [
      "AI",
      "Machine Learning",
      "Stripe API",
      "Jest",
      "Cucumber",
      "TestNG",
      "Jira",
      "Confluence",
      "Postman",
      "Swagger",
      "Func & Tech Documentation",
    ],
  },
];
